import { motion } from "framer-motion"

export const VerticalGradient = ({ done, y = 0, className, transition }) => {
    return (
        <motion.div
            initial={{ y: y, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={transition}
            className={`bg-gradient-to-b w-[2px] h-full ${done ? "from-success/0 via-success to-success/0" : "from-warn/0 via-warn to-warn/0"} ${className}`}
        />
    )
}

